@if (this.profondeurActuelle() === '01') {
  <div
    class="bg-components-background-neutral-lightest m-xs p-xs gap-xs shadow-bottom flex w-[424px] flex-wrap justify-start rounded-sm"
  >
    @for (pointDepart of pointsDepart; track $index) {
      @if (pointDepart.selectionne) {
        <div
          class="border-stroke-neutral-medium text-components-content-neutral-quaternary p-xs flex h-[64px] w-[200px] flex-col items-center justify-center rounded-sm border"
        >
          @if (pointDepart.sousTitre) {
            <span class="paragraph-small-medium">{{ pointDepart.sousTitre }}</span>
          }
          <span class="paragraph-medium-semibold">{{ pointDepart.titre }}</span>
        </div>
      } @else {
        <div
          class="border-stroke-neutral-medium text-components-content-neutral-primary hover:border-stroke-primary-main hover:bg-components-background-primary-lightest p-xs flex h-[64px] w-[200px] cursor-pointer flex-col items-center justify-center rounded-sm border"
          (click)="clickHandler(pointDepart)"
        >
          @if (pointDepart.sousTitre) {
            <span class="paragraph-small-medium">{{ pointDepart.sousTitre }}</span>
          }
          <span class="paragraph-medium-semibold">{{ pointDepart.titre }}</span>
        </div>
      }
    }
  </div>
}
